import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { getFormPackSchema, getUiSchema } from './Schema';

export default class NewFormPack extends PureComponent {
  onSubmit = ({ formData }) => {
    this.props.onCreate(formData);
  };

  render() {
    const { fetching, forms, formPack, type } = this.props;

    return (
      <div className="dealer-list-container">
        <Form
          schema={getFormPackSchema(formPack, forms, type)}
          uiSchema={getUiSchema(type)}
          formData={formPack}
          onSubmit={this.onSubmit}
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching}
            type="submit"
          >
            Submit
          </Button>
        </Form>
      </div>
    );
  }
}

NewFormPack.propTypes = {
  fetching: PropTypes.bool,
  formPack: PropTypes.object,
  forms: PropTypes.array,
  onCreate: PropTypes.func,
  type: PropTypes.string,
};
